import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    topBar: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: '20px'
    },
    container: {
      margin: 'auto',
      width: '80%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '20px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
